module.exports = __webpack_public_path__ + "img/logo_stacked_right@2x.a182d1c6.png";